// extracted by mini-css-extract-plugin
export default {"giftOrPromoRowWrapper":"Xw-z","giftOrPromoSelector":"Yw-z","disabled":"Zw-z","subTitle":"_w-z","selectShipAddressMessage":"ax-z","changePayment":"bx-z"};